import { i18n } from "@lingui/core";
import { messages as en } from "../../locales/en.mjs";
import { messages as nb } from "../../locales/nb.mjs";
import { messages as sv } from "../../locales/sv.mjs";
import { getPodletMetaData } from "./lit-util.js";

// Load all translations
i18n.load({ en, nb, sv });

// Wait for DOM to be ready before reading data attribute
function initializeLocale() {
	const metaData = getPodletMetaData();
	const locale = metaData.locale || "en";

	i18n.activate(locale);
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initializeLocale);
} else {
	initializeLocale();
}

export { i18n };
